import { createSlice } from '@reduxjs/toolkit';

// Начальное состояние слайсера
const initialState = {
    icon: 'star_big',
    count: 3,
    position: 'Ultras', // Дефолтное значение для position
    chain: 'solana', // Дефолтное значение для chain
    sortname: 'SOL', // Дефолтное значение для sortname
};

// Создание слайсера 'ultras'
const ultrasSlice = createSlice({
    name: 'ultras',
    initialState,
    reducers: {
        // Редюсер для изменения иконки
        setIcon: (state, action) => {
            state.icon = action.payload; // Устанавливаем новое значение для 'icon'
        },
        // Редюсер для изменения количества
        setCount: (state, action) => {
            state.count = action.payload; // Устанавливаем новое значение для 'count'
        },
        // Редюсер для обновления обоих значений
        updateUltra: (state, action) => {
            const { icon, count } = action.payload;
            state.icon = icon !== undefined ? icon : state.icon;
            state.count = count !== undefined ? count : state.count;
        },
        // Редюсер для изменения позиции
        setPosition: (state, action) => {
            state.position = action.payload; // Устанавливаем новое значение для 'position'
        },
        // Редюсер для обновления всех значений
        updateUltraWithPosition: (state, action) => {
            const { icon, count, position, chain, sortname } = action.payload;
            state.icon = icon !== undefined ? icon : state.icon;
            state.count = count !== undefined ? count : state.count;
            state.position = position !== undefined ? position : state.position;
            state.chain = chain !== undefined ? chain : state.chain;
            state.sortname = sortname !== undefined ? sortname : state.sortname; // Обновляем sortname, если передано
        },
        // Редюсер для изменения chain
        setChain: (state, action) => {
            state.chain = action.payload; // Устанавливаем новое значение для 'chain'
        },
        // Редюсер для изменения sortname
        setSortname: (state, action) => {
            state.sortname = action.payload; // Устанавливаем новое значение для 'sortname'
        },
    },
});

// Экспортируем действия для использования в компонентах
export const { setIcon, setCount, updateUltra, setPosition, updateUltraWithPosition, setChain, setSortname } = ultrasSlice.actions;

// Экспортируем редюсер для добавления в хранилище
export default ultrasSlice.reducer;
